import { Component, h, Prop } from '@stencil/core';

@Component({
  tag: 'zeudy-video-curtain-ui',
  styleUrl: 'zeudy-video-curtain-ui.scss',
  shadow: true,
})
export class CurtainUI {
  /**
   * Props
   */
  @Prop() actionUrl: string;

  render() {
    return (
      <div class="curtain" part="base">
        <div class="content" part="curtain-content">
          <slot />
        </div>
      </div>
    );
  }
}
